import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../CSS/Home.css";

const Home = () => {
  const videos = [
    require("../assets/slider1.mp4"),
    require("../assets/slider2.mp4"),
  ];

  const [currentVideo, setCurrentVideo] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideo((prev) => (prev + 1) % videos.length);
    }, 6970); 
    return () => clearInterval(interval);
  }, [videos.length]);

  const handlePrev = () => {
    setCurrentVideo((prev) =>
      prev === 0 ? videos.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentVideo((prev) =>
      prev === videos.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="home-wrapper">
      <div className="home-container">
        <video
          key={currentVideo}
          className="bg-video"
          autoPlay
          muted
          playsInline
          loop
        >
          <source src={videos[currentVideo]} type="video/mp4" />
        </video>

        <button className="arrow left" onClick={handlePrev}>
          ❮
        </button>
        <button className="arrow right" onClick={handleNext}>
          ❯
        </button>

        <div className="glass-box">
          <h1>Clean Energy for a Better Future</h1>
          <p>
            Harness the power of <span>Wind</span>, <span>Solar</span>, and{" "}
            <span>Green Energy</span> solutions to build a sustainable tomorrow.
          </p>
          <div className="button-group">
            <button className="btn" onClick={() => navigate("/services")}>
              Services
            </button>
            <button className="btn btn-outline" onClick={() => navigate("/about")}>
              Learn More
            </button>
          </div>
        </div>
      </div>

      <section className="about-section">
        <h2>Welcome to AmphiGreen</h2>
        <p>
          AmphiGreen is a pioneering green energy company dedicated to providing
          innovative and sustainable solutions for homes, businesses, and communities.
          Our focus is on renewable energy, smart meters, and efficient power distribution,
          helping you reduce carbon footprint while saving on energy costs.
        </p>
        <p>
          With AmphiGreen, you’re not just using electricity – you’re embracing a sustainable
          lifestyle and contributing to a healthier planet.
        </p>
      </section>

      <div className="services-cta">
        <h2>Ready to make the switch to clean energy?</h2>

        <button className="btn" onClick={() => navigate("/contact")}>
          Contact Us Today
        </button>
      </div>
    </div>
  );
};

export default Home;
